import React from 'react';
import Hariltsagch from './hariltsagch';

const PageList = () => <Hariltsagch />;

export default PageList;
